import React from 'react';

interface SpinnerProps {
  size?: string;
  className?: string;
  variant?: 'default' | 'pulse' | 'dots';
}

export default function Spinner({ size = "h-8 w-8", className = "", variant = "default" }: SpinnerProps) {
  if (variant === 'pulse') {
    return (
      <div className={`flex justify-center items-center ${className}`} role="status" aria-label="Loading">
        <div className={`${size} rounded-full bg-strivre-burgundy animate-pulse-gentle`}></div>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  if (variant === 'dots') {
    return (
      <div className={`flex justify-center items-center gap-1 ${className}`} role="status" aria-label="Loading">
        <div className="w-2 h-2 rounded-full bg-strivre-burgundy animate-pulse" style={{ animationDelay: '0ms' }}></div>
        <div className="w-2 h-2 rounded-full bg-strivre-burgundy animate-pulse" style={{ animationDelay: '200ms' }}></div>
        <div className="w-2 h-2 rounded-full bg-strivre-burgundy animate-pulse" style={{ animationDelay: '400ms' }}></div>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  return (
    <div className={`flex justify-center items-center ${className}`} role="status" aria-label="Loading">
      <div className={`animate-spin rounded-full border-2 border-current border-t-transparent ${size}`}></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}